import { render, staticRenderFns } from "./preorderWidget.vue?vue&type=template&id=5ecec2af&"
var script = {}
import style0 from "./preorderWidget.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecec2af')) {
      api.createRecord('5ecec2af', component.options)
    } else {
      api.reload('5ecec2af', component.options)
    }
    module.hot.accept("./preorderWidget.vue?vue&type=template&id=5ecec2af&", function () {
      api.rerender('5ecec2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preorderWidget/preorderWidget.vue"
export default component.exports